// #region Global Imports
import styled from "styled-components";
// #endregion Global Imports

export const Image = styled.img`
    width: 100%;
`;
